export default __webpack_public_path__ + "static/media/accommodation.07ad84df.svg";